export default {
    cardhex: '',
    bindcarduid: 0,
    bindcardhex: '',
}